<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div *ngIf="isAddForm" class="row my-4">
		<div class="col-12 col-lg">
			<label for="employeeType" class="form-label fw-bold"
				>Type d'employé</label
			>
			<select
				*ngIf="this.isAddForm"
				required
				id="employeeType"
				class="form-select"
				name="employeeType"
				formControlName="employeeType"
				aria-label="Sélectionner un type"
				[ngClass]="{
					'is-invalid': employeeType.invalid,
					'is-valid': employeeType.dirty && employeeType.valid
				}"
				(change)="toggleEmployeeTypeSelected()"
			>
				<option [value]="EmployeeTypeEnum.EMP">Employé(e) du centre</option>
				<option [value]="EmployeeTypeEnum.EXT">
					Intervenant(e) extérieur(e)
				</option>
			</select>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('firstName')" class="col-12 col-lg">
			<label for="firstName" class="form-label fw-bold">Prénom</label>
			<input
				autocomplete="off"
				required
				type="text"
				class="form-control"
				id="firstName"
				name="firstName"
				formControlName="firstName"
				[ngClass]="{
					'is-invalid': firstName.invalid,
					'is-valid': firstName.dirty && firstName.valid
				}"
			/>
			<div *ngIf="firstName.invalid" class="invalid-feedback">
				<span *ngIf="firstName.errors?.required">Un prénom est requis</span>
				<span *ngIf="firstName.errors?.maxlength"
					>Le prénom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="firstName.errors?.pattern"
					>Le prénom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
		<div *ngIf="form.contains('lastName')" class="col-12 col-lg">
			<label for="inputLastName" class="form-label fw-bold">Nom</label>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputLastName"
				name="lastName"
				formControlName="lastName"
				[ngClass]="{
					'is-invalid': lastName.invalid,
					'is-valid': lastName.dirty && lastName.valid
				}"
			/>
			<div *ngIf="lastName.invalid" class="invalid-feedback">
				<span *ngIf="lastName.errors?.required">Un nom est requis</span>
				<span *ngIf="lastName.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="lastName.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('address')" class="col-12 col-lg">
			<label for="inputAddresse" class="form-label theme-main-color fw-bold"
				>Adresse du domicile</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputAddresse"
				name="address"
				(typeaheadOnSelect)="onAddressSelect($event, false)"
				(keyup)="selectedAddressKeyUp($event.target, false)"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="address"
				[ngClass]="{
					'is-invalid':
						address.invalid ||
						(address.dirty &&
							!(isAddressDefault.value || isAddressSelected.value)),
					'is-valid': address.dirty && address.valid && isAddressSelected.value
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('workplaceAddress')" class="col-12 col-lg">
			<label
				for="inputWorkplaceAddress"
				class="form-label theme-main-color fw-bold"
				>Adresse siège social</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputWorkplaceAddress"
				name="workplaceAddress"
				(typeaheadOnSelect)="onAddressSelect($event, true)"
				(keyup)="selectedAddressKeyUp($event.target, true)"
				[typeahead]="workplaceAddressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="workplaceAddress"
				[ngClass]="{
					'is-invalid':
						workplaceAddress.invalid ||
						(workplaceAddress.dirty &&
							!(
								isWorkplaceAddressDefault.value ||
								isWorkplaceAddressSelected.value
							)),
					'is-valid':
						workplaceAddress.dirty &&
						workplaceAddress.valid &&
						isWorkplaceAddressSelected.value
				}"
			/>
		</div>
	</div>

	<div *ngIf="this.emailActive && this.isAddForm" class="row my-4">
		<div class="col-12 col-lg">
			<label for="email" class="form-label fw-bold">Email</label>
			<input
				class="form-control"
				id="email"
				name="email"
				formControlName="email"
				[ngClass]="{
					'is-invalid': form.errors?.emailRequired
						? true
						: false || !email.valid,
					'is-valid':
						email.dirty && email.valid && !form.errors?.emailRequired
							? true
							: false
				}"
			/>
		</div>
	</div>
	<div class="row my-4">
		<div *ngIf="form.contains('birthDate')" class="col-12 col-lg">
			<label for="birthDate" class="form-label fw-bold"
				>Date de naissance</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="birthDate"
				name="birthDate"
				formControlName="birthDate"
				[ngClass]="{
					'is-invalid': birthDate.invalid,
					'is-valid': birthDate.dirty && birthDate.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('phone')" class="col-12 col-lg">
			<label for="phone" class="form-label fw-bold">Numéro de téléphone</label>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="phone"
				name="phone"
				formControlName="phone"
				[ngClass]="{
					'is-invalid': phone.invalid,
					'is-valid': phone.dirty && phone.valid
				}"
			/>
			<div *ngIf="phone.invalid" class="invalid-feedback">
				<span *ngIf="phone.errors?.pattern"
					>Veuillez saisir un numéro de téléphone correct : 0123456789</span
				>
			</div>
		</div>
	</div>
	<div class="row my-4">
		<div class="col-12">
			<label class="form-label fw-bold"
				>Couleur associée à l'intervenant :</label
			>
			<div class="d-flex flex-wrap">
				<div
					*ngFor="let color of colorsPastel; let idx = index"
					class="color-circle mx-1 my-1 position-relative"
					[ngClass]="{ 'selected-color': employee.colorIndex === idx }"
					[ngStyle]="{ 'background-color': color.secondary }"
					(click)="setEmployeeColor(idx)"
				>
					<i
						*ngIf="employee.colorIndex === idx"
						class="bi bi-check-lg text-white position-absolute top-50 start-50 translate-middle"
					></i>
				</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="!isAddForm" class="col-12 col-lg-4">
			<label for="centre" class="form-label fw-bold">Centre</label>
			<span class="form-control-plaintext" id="centre">{{
				employee.serviceCenter.name
			}}</span>
		</div>

		<div *ngIf="isAreaActive" class="col-12 col-8-lg">
			<label for="secteurs" class="form-label fw-bold">Secteur(s)</label>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="let area of areaList | orderBy : 'name' : 'asc'"
				>
					<div>
						<input
							type="checkbox"
							name="{{ area.id }}"
							class="form-check-input"
							[value]="area"
							[checked]="isAreaCheck(area)"
							[ngClass]="{
								'theme-main-color-check': isAreaCheck(area)
							}"
							(change)="updateSelectedArea($event, area)"
						/>
						<label class="ms-2 form-check-label text-dark">
							{{ area.name }}
						</label>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 col-8-lg">
			<label for="departments" class="form-label fw-bold">Service(s)</label>
			<div class="row">
				<div
					class="col-md-4 check"
					*ngFor="
						let department of centerDepartments | orderBy : 'name' : 'asc'
					"
				>
					<div>
						<input
							type="checkbox"
							name="{{ department.id }}"
							class="form-check-input"
							[value]="department"
							[checked]="isDepartmentCheck(department)"
							[ngClass]="{
								'theme-main-color-check': isDepartmentCheck(department)
							}"
							(change)="updateSelectedDepartment($event, department)"
						/>
						<label class="ms-2 form-check-label text-dark">
							{{ department.name }}
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="!isAddForm" class="col-12 col-lg-12">
			<label for="employeeType" class="form-label fw-bold"
				>Type d'employé</label
			>
			<span class="form-control-plaintext">{{
				employee.type === 'EMP' ? 'Employé(e)' : 'Intervenant(e) extérieur(e)'
			}}</span>
		</div>

		<div class="col-12 col-lg">
			<label for="competence" class="form-label fw-bold">Compétence(s)</label>
			<div class="row">
				<div
					class="col-md-6 check"
					*ngFor="let competence of competences | orderBy : 'name' : 'asc'"
				>
					<input
						type="checkbox"
						name="{{ competence }}"
						class="form-check-input"
						[value]="competence"
						[checked]="isCompetenceCheck(competence)"
						[ngClass]="{
							'theme-main-color-check': isCompetenceCheck(competence)
						}"
						(change)="updateSelectedCompetence($event, competence)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ competence.name.replaceAll('_', ' ') }}
					</label>
				</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<label for="specialities" class="form-label fw-bold">Spécialité(s)</label>
		<div class="row">
			<div
				class="col-md-6 check"
				*ngFor="let specialite of listSpecialite | orderBy : 'name' : 'asc'"
			>
				<div *ngIf="specialite.id !== 0">
					<input
						type="checkbox"
						name="{{ specialite.id }}"
						class="form-check-input"
						[value]="specialite"
						[checked]="isSpecialiteCheck(specialite)"
						[ngClass]="{
							'theme-main-color-check': isSpecialiteCheck(specialite)
						}"
						(change)="updateSelectedSpecialite($event, specialite)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ specialite.name }}
					</label>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div
			*ngIf="form.contains('autoAssignment') && emailActive"
			class="form-check form-switch ms-2"
		>
			<input
				class="form-check-input theme-main-border-color"
				type="checkbox"
				id="autoAssignment"
				formControlName="autoAssignment"
				[ngClass]="{
					'theme-main-color-check': autoAssignment.value
				}"
			/>
			<label class="form-check-label text-dark" for="autoAssignment"
				>Auto-Affectation</label
			>
		</div>
	</div>

	<div
		*ngIf="form.contains('workingHoursPerWeek') && emailActive"
		class="row my-4"
	>
		<label class="form-label fw-bold col-6"
			>Nombre d'heures travaillées dans la semaine</label
		>
		<div class="row">
			<div class="col-12 col-lg-6">
				<input
					type="number"
					formControlName="workingHoursPerWeek"
					class="form-control"
					[ngClass]="{
						'is-invalid': workingHoursPerWeek.invalid,
						'is-valid': workingHoursPerWeek.dirty && workingHoursPerWeek.valid
					}"
				/>
				<div *ngIf="workingHoursPerWeek.invalid" class="invalid-feedback">
					<span *ngIf="workingHoursPerWeek.errors?.required"
						>Veuillez saisir un nombre d'heures travaillées</span
					>
					<span *ngIf="workingHoursPerWeek.errors?.min"
						>Veuillez saisir un nombre d'heures travaillées supérieur à 0</span
					>
					<span *ngIf="workingHoursPerWeek.errors?.max"
						>Veuillez saisir un nombre d'heures travaillées inférieur à 60</span
					>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
